<template>
  <div class="regulation-footer-link">
    <a
      :href="regulationUrl"
      class="custom-link link-green text-base-small"
      style="vertical-align: baseline;"
      target="_blank"
      rel="noopener noreferrer"
      download
    >
      {{ resolvedLinkLabel }}
    </a>
  </div>
</template>

<script>
import { REGULATION_PDF_URL } from "~/constants/legal";

export default {
  name: "RegulationFooterLink",
  props: {
    regulationUrl: {
      type: String,
      default: REGULATION_PDF_URL
    },
    linkLabel: {
      type: String,
      default: ""
    }
  },
  computed: {
    resolvedLinkLabel() {
      return this.linkLabel || this.$t("legal.regulation.pdf_label");
    }
  }
};
</script>

<style scoped>
.regulation-footer-link {
  padding: 12px 0;
  text-align: center;
}
</style>
